import React from "react";
import StatusPage from "../components/StatusPage.js";

const Unauthorized = () => {
  return (
    <StatusPage icon='bi-lock' title='Sorry!'>
      <h3>You do not have permission to view this page.</h3>
    </StatusPage>
  );
};

export default Unauthorized;
